import { getBaseQuery, getBaseUrl } from '../../Utils'
import { createApi } from '@reduxjs/toolkit/query/react'

const baseUrl = `${getBaseUrl()}/API/v3/Log4net`
export const Log4Net = createApi({
    reducerPath: 'Log4Net',
    baseQuery: getBaseQuery(baseUrl),
    endpoints: (builder) => ({
        GetLog4netConfig: builder.mutation<any, void>({
            query: () => ({
                url: '',
                method: 'GET',
            }),
            transformResponse: (response: any) => {
                return response.data ? response.data : []
            },
        }),

        GetLogFileData: builder.mutation<any, string>({
            query: (logfiletype) => ({
                url: '/logfileType',
                method: 'GET',
                params: { logfiletype },
            }),
            transformResponse: (response: any) => {
                return response.data ? response.data.data : []
            },
        }),

        SaveLog4netConfig: builder.mutation<any, any>({
            query: (Log4netData) => ({
                url: '',
                method: 'POST',
                body: Log4netData,
            }),
            transformResponse: (response: any) => {
                return response.data ? response.data : []
            },
        }),
    }),
})

// Export the hooks for the API endpoints
export const {
    useGetLog4netConfigMutation,
    useGetLogFileDataMutation,
    useSaveLog4netConfigMutation,
} = Log4Net
